export const listMenus = {
   type_1: [{arr: 1, name: 'Textbox', id: 'f-textbox', icon: 'text_format'},
      {arr: 1, name: 'Choice', id: 'f-choice', icon: 'format_list_numbered_rtl'},
      {arr: 1, name: 'Yes/No', id: 'f-radio', icon: 'text_rotation_none'},
      {arr: 1, name: 'DateTime', id: 'f-date', icon: 'date_range'},
      {arr: 1, name: 'Number', id: 'f-number', icon: 'looks_one'}],
   type_2: [{arr: 2, name: 'Phone', id: 'f-phone', icon: 'contact_phone'},
      {arr: 2, name: 'Currency', id: 'f-currency', icon: 'attach_money'},
      {arr: 2, name: 'Website', id: 'f-website', icon: 'public'},
      {arr: 2, name: 'Email', id: 'f-email', icon: 'email'}],
   type_3: [{arr: 3, name: 'Address ', id: 'f-address', icon: 'art_track'},
      {arr: 3, name: 'Name', id: 'f-name', icon: 'text_rotation_none'},
      {arr: 3, name: 'File Upload ', id: 'f-upload', icon: 'cloud_upload'},
      {arr: 3, name: 'Signature', id: 'f-signature', icon: 'font_download'}],
   type_4: [{arr: 4, name: 'Section', id: 'f-section', icon: 'zoom_out_map'}],
   type_5: [{arr: 5, name: 'Table', id: 'f-table', icon: 'table_chart'}],
   type_6: [{arr: 6, name: 'Textbox', id: 't-textbox', icon: 'text_format'},
      {arr: 6, name: 'Choice', id: 't-choice', icon: 'format_list_numbered_rtl'},
      {arr: 6, name: 'Yes/No', id: 't-radio', icon: 'text_rotation_none'},
      {arr: 6, name: 'DateTime', id: 't-date', icon: 'date_range'},
      {arr: 6, name: 'Number', id: 't-number', icon: 'looks_one'},
      {arr: 6, name: 'Currency', id: 't-currency', icon: 'attach_money'},
      {arr: 6, name: 'Phone', id: 't-phone', icon: 'contact_phone'},
      {arr: 6, name: 'Email', id: 't-email', icon: 'email'},
      {arr: 6, name: 'Website', id: 't-website', icon: 'public'},
      {arr: 6, name: 'Calculation', id: 't-calculate', icon: 'plus_one'}]
};




